import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useOrg } from '../org/OrgContext';
import { useAuth } from '../auth/AuthContext';
import Icon from './Icon';

// Main sections per division. `match` widens the active state to sub-pages.
const NAV = {
  GFM: [
    { to: '/dashboard',       label: 'Dashboard' },
    { to: '/inventory/main',  label: 'Inventory', match: '/inventory' },
    { to: '/gfm/deliveries',  label: 'Orders' },
    { to: '/history',         label: 'History' },
    { to: '/teams',           label: 'Teams' },
  ],
  GPM: [
    { to: '/dashboard',       label: 'Dashboard' },
    { to: '/gpm/inventory',   label: 'Inventory' },
    { to: '/gpm/deliveries',  label: 'Orders' },
    { to: '/gpm/history',     label: 'History' },
  ],
  Fleet: [
    { to: '/dashboard',       label: 'Dashboard' },
    { to: '/vehicles',        label: 'Vehicles' },
    { to: '/fleetChecks',     label: 'Vehicle check' },
    { to: '/fleetChecksList', label: 'Review checks' },
  ],
  Assets: [
    { to: '/dashboard',       label: 'Dashboard' },
    { to: '/assets',          label: 'Assets' },
    { to: '/tickets',         label: 'Tickets' },
  ],
};

function isActive(pathname, item) {
  const base = item.match || item.to;
  return pathname === base || pathname.startsWith(base + '/');
}

export default function Header() {
  const { org } = useOrg();
  const { user, logout } = useAuth();
  const { pathname } = useLocation();

  const items = (user && NAV[org]) || [];
  const isAdmin = user && (user.username === 'admin' || user.role === 'admin');

  return (
    <header className="header">
      <div className="header-inner">
        <Link to={user ? '/dashboard' : '/login'} className="brand">
          <span className="brand-mark"><img src="/GFMLogo.ico" alt="" /></span>
          <span className="brand-name">{process.env.REACT_APP_BRAND_NAME || 'Gateway'}</span>
        </Link>

        {user && org && (
          <Link to="/choose" className="division-chip" title="Switch division">
            {org}
            <Icon name="chevronDown" size={14} />
          </Link>
        )}

        {items.length > 0 && (
          <nav className="nav" aria-label="Main">
            {items.map(item => (
              <Link
                key={item.to}
                to={item.to}
                className={isActive(pathname, item) ? 'active' : undefined}
                aria-current={isActive(pathname, item) ? 'page' : undefined}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}

        {user && (
          <div className="header-user">
            <span className="header-username">{user.username}</span>
            {isAdmin && (
              <Link to="/admin/users" className="btn on-dark small">Admin</Link>
            )}
            <button
              className="btn on-dark small"
              onClick={() => { logout(); window.location.href = '/'; }}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
